export default __webpack_public_path__ + "static/media/timage2.3f2cf1f6.jpg";